import axios from 'axios'
import utils from '../utils'

const credentials = {
  endpoint:
    utils.constants.env === 'PRD'
      ? 'https://muuve-f6d0fdf533abafa84e072b32e350eb963839ff7a.muuve.biz/v1alpha1/graphql'
      : 'https://muuve-stg-f6d0fdf533abafa84e072b32e350eb963839ff7a.muuve.biz/v1alpha1/graphql',
  secret: utils.constants.env === 'PRD' ? 'muuve-production-secret-W2o3n4g5' : 'muuve-W2o3n4g5',
}

const execute = async (query, variables = undefined) => {
  const params = {
    method: 'POST',
    url: credentials.endpoint,
    headers: { 'x-hasura-admin-secret': credentials.secret },
    data: { query, variables },
  }

  const response = await axios(params)

  return response.data.data
}

export default { execute }



// WEBPACK FOOTER //
// ./src/config/hasura.js